<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  label: {
    type: String
  },
  name: {
    type: String
  },
  value: {
    type: String
  },
  modelValue: {
    type: [String, Number]
  },
  required: {
    type: Boolean
  },
  disabled: {
    type: Boolean
  }
})

const { label, name, value, modelValue, required, disabled } = toRefs(props)
</script>
<template>
  <label class="flex items-center gap-2 text-lg font-bold">
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="modelValue === value"
      @change="$emit('update:modelValue', $event.target.value)"
      class="radio border-scp-cyan-green checked:bg-scp-cyan-green"
      :required="required"
      :disabled="disabled"
    />
    <span>{{ label }}</span>
  </label>
</template>
<style lang="scss" scoped></style>
